<template>
  <div>
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div class="flex">
      <SideBar />
      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-y-auto heightfix bg-white"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div class="flex flex-col gap-5 p-10 w-full">
          <!-- Header with Back Button -->
          <div class="">
            <router-link
              :to="{ name: 'InstructorQuizs' }"
              class="inline-flex items-center gap-2 bg-blues hover:bg-blue-600 text-xs font-bold text-white px-5 py-2 rounded-full transition-all duration-200 hover:shadow-lg"
            >
              Back
            </router-link>
          </div>
          <!-- Scoreboard Header -->
          <div class="">
            <div
              class="bg-gradient-to-r from-[#F9FAFC] to-white py-4 px-6 flex flex-col md:flex-row items-center justify-between rounded-2xl border border-gray-100"
            >
              <div class="mb-4 md:mb-0">
                <div class="flex items-center gap-3">
                  <div
                    class="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5 text-blues"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                      />
                    </svg>
                  </div>

                  <div>
                    <h2 class="text-md font-bold text-blues">
                      {{ quiz_name }}
                    </h2>
                    <p class="text-sm text-gray-500">Quiz Scoreboard</p>
                  </div>
                </div>
              </div>

              <div class="flex gap-3 w-full md:w-auto">
                <div class="">
                  <div class="relative w-full md:max-w-80">
                    <div
                      class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-4 w-4 text-gray-400"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                        />
                      </svg>
                    </div>
                    <input
                      type="text"
                      v-model="searching"
                      @input="quizgetscoreinfo(1)"
                      placeholder="Search..."
                      class="w-full rounded-xl border border-gray-200 bg-white pl-10 pr-10 py-2 text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                    />
                    <button
                      v-if="searching"
                      @click="clearSearch"
                      class="absolute inset-y-0 right-0 pr-3 flex items-center"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-4 w-4 text-gray-400 hover:text-gray-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  </div>
                </div>

                <button
                  class="px-5 py-2 rounded-2xl font-semibold text-sm flex items-center justify-center gap-2 transition-all duration-200"
                  @click="scoreDownload"
                  :disabled="isDownload || scoredetails.length === 0"
                  :class="[
                    scoredetails.length > 0
                      ? 'bg-blues hover:bg-blue-700 cursor-pointer text-white '
                      : 'bg-gray-300 cursor-not-allowed text-gray-500 ',
                  ]"
                >
                  <span v-if="!isDownload">Download</span>
                  <span v-else class="flex items-center gap-2">
                    <svg
                      class="animate-spin h-4 w-4 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        class="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        stroke-width="4"
                      ></circle>
                      <path
                        class="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 00-8 8z"
                      ></path>
                    </svg>
                    Download...
                  </span>
                </button>
              </div>
            </div>
          </div>

          <!-- Stats Cards -->
          <div>
            <!-- Loading -->
            <div v-if="loading" class="grid grid-cols-1 md:grid-cols-3 gap-5">
              <div
                v-for="n in 3"
                :key="n"
                class="animate-pulse bg-white rounded-2xl border border-gray-200 p-5 shadow-sm"
              >
                <div class="flex items-center justify-between">
                  <div>
                    <div class="h-3 w-24 bg-gray-200 rounded mb-3"></div>
                    <div class="h-7 w-16 bg-gray-300 rounded"></div>
                  </div>
                  <div class="w-12 h-12 bg-gray-200 rounded-xl"></div>
                </div>
              </div>
            </div>

            <!-- Cards -->
            <div v-else class="grid grid-cols-1 md:grid-cols-3 gap-5">
              <!-- Visited -->
              <div
                class="relative overflow-hidden bg-white rounded-2xl border border-gray-200 shadow-sm hover:shadow-lg transition-all duration-300"
              >
                <div class="absolute top-0 left-0 w-full h-1 bg-blue-500"></div>

                <div class="p-5 flex items-center justify-between">
                  <div>
                    <p
                      class="text-xs uppercase tracking-wider text-gray-800 font-semibold"
                    >
                      Total Users
                    </p>

                    <h2 class="text-3xl font-bold text-blue-800 mt-2">
                      {{ totalcount || 0 }}
                    </h2>
                  </div>

                  <div
                    class="w-14 h-14 rounded-2xl bg-blue-100 flex items-center justify-center"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="w-7 h-7 text-blue-600"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                      />
                    </svg>
                  </div>
                </div>
              </div>

              <!-- Appeared -->
              <div
                class="relative overflow-hidden bg-white rounded-2xl border border-gray-200 shadow-sm hover:shadow-lg transition-all duration-300"
              >
                <div
                  class="absolute top-0 left-0 w-full h-1 bg-emerald-500"
                ></div>

                <div class="p-5 flex items-center justify-between">
                  <div>
                    <p
                      class="text-xs uppercase tracking-wider text-gray-800 font-semibold"
                    >
                      Appeared
                    </p>

                    <h2 class="text-3xl font-bold text-emerald-600 mt-2">
                      {{ updateDetails?.completed_count || 0 }}
                    </h2>
                  </div>

                  <div
                    class="w-14 h-14 rounded-2xl bg-emerald-100 flex items-center justify-center"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="w-7 h-7 text-emerald-600"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </div>
                </div>
              </div>

              <!-- Not Attended -->
              <div
                class="relative overflow-hidden bg-white rounded-2xl border border-gray-200 shadow-sm hover:shadow-lg transition-all duration-300"
              >
                <div class="absolute top-0 left-0 w-full h-1 bg-rose-500"></div>

                <div class="p-5 flex items-center justify-between">
                  <div>
                    <p
                      class="text-xs uppercase tracking-wider text-gray-800 font-semibold"
                    >
                      Not Attended
                    </p>

                    <h2 class="text-3xl font-bold text-rose-600 mt-2">
                      {{ updateDetails?.not_completed_count || 0 }}
                    </h2>
                  </div>

                  <div
                    class="w-14 h-14 rounded-2xl bg-rose-100 flex items-center justify-center"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="w-7 h-7 text-rose-600"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Table Section -->
          <div>
            <div
              class="w-full overflow-x-auto rounded-xl border border-gray-200 shadow-sm bg-white"
            >
              <table
                class="min-w-full divide-y divide-gray-200 text-sm overflow-visible"
              >
                <thead>
                  <tr class="bg-gray-50 text-blues">
                    <th
                      scope="col"
                      class="px-6 py-3.5 font-semibold text-center border-b border-r border-gray-200 w-16"
                    >
                      S.NO
                    </th>
                    <th
                      scope="col"
                      class="px-6 py-3.5 font-semibold text-left border-b border-r border-gray-200 min-w-[200px]"
                    >
                      Email
                    </th>
                    <th
                      scope="col"
                      class="px-6 py-3.5 font-semibold text-left border-b border-r border-gray-200 min-w-[180px]"
                    >
                      Learner
                    </th>
                    <th
                      scope="col"
                      class="px-4 py-3.5 border-b border-r border-gray-200 min-w-[130px]"
                      title=" Correct questions out of total questions"
                    >
                      <div class="flex items-center justify-center gap-1.5">
                        <span class="font-semibold text-blues"
                          >Correct / Total</span
                        >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="w-3.5 h-3.5 text-gray-400 shrink-0"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <circle cx="12" cy="12" r="10" />
                          <path d="M12 16v-4M12 8h.01" />
                        </svg>
                      </div>
                    </th>

                    <th
                      scope="col"
                      class="px-4 py-3.5 border-b border-r border-gray-200 min-w-[130px]"
                      title="Total number of attempts"
                    >
                      <div class="flex items-center justify-center gap-1.5">
                        <span class="font-semibold text-blues">Total Att.</span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="w-3.5 h-3.5 text-gray-400 shrink-0"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <circle cx="12" cy="12" r="10" />
                          <path d="M12 16v-4M12 8h.01" />
                        </svg>
                      </div>
                    </th>

                    <th
                      scope="col"
                      class="px-4 py-3.5 border-b border-r border-gray-200 min-w-[130px]"
                      title="Attempts made by each student"
                    >
                      <div class="flex items-center justify-center gap-1.5">
                        <span class="font-semibold text-blues"
                          >Student Att.</span
                        >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="w-3.5 h-3.5 text-gray-400 shrink-0"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <circle cx="12" cy="12" r="10" />
                          <path d="M12 16v-4M12 8h.01" />
                        </svg>
                      </div>
                    </th>
                    <th
                      scope="col"
                      class="px-6 py-3.5 font-semibold text-center border-b border-r border-gray-200 w-36"
                    >
                      Status
                    </th>
                    <th v-if="this.$route.query.lesson_quize === 'false'"
                      scope="col"
                      class="px-6 py-3.5 font-semibold text-center border-b border-r border-gray-200 w-36"
                    >
                      Publish
                    </th>
                    <th
                      scope="col"
                      class="px-6 py-3.5 font-semibold text-center border-b border-r border-gray-200 min-w-[160px]"
                    >
                      Date
                    </th>
                    <th
                      scope="col"
                      class="px-6 py-3.5 font-semibold text-center border-b border-r border-gray-200 w-36"
                    >
                      Action
                    </th>
                  </tr>
                </thead>

                <tbody v-if="loading" class="divide-y divide-gray-200 bg-white">
                  <tr
                    v-for="n in 5"
                    :key="'loader-' + n"
                    class="animate-pulse divide-x divide-gray-100 whitespace-nowrap"
                  >
                    <td class="py-3 px-6 text-center">
                      <div class="h-3.5 w-6 bg-gray-200 rounded mx-auto"></div>
                    </td>
                    <td class="py-3 px-6">
                      <div class="h-3.5 w-40 bg-gray-100 rounded"></div>
                    </td>
                    <td class="py-3 px-6">
                      <div class="h-3.5 w-32 bg-gray-100 rounded"></div>
                    </td>
                    <td class="py-3 px-6 text-center">
                      <div class="h-3.5 w-12 bg-gray-100 rounded mx-auto"></div>
                    </td>
                    <td class="py-3 px-6 text-center">
                      <div
                        class="h-6 w-24 bg-gray-100 rounded-full mx-auto"
                      ></div>
                    </td>
                    <td class="py-3 px-6 text-center">
                      <div
                        class="h-6 w-24 bg-gray-100 rounded-full mx-auto"
                      ></div>
                    </td>
                    <td class="py-3 px-6 text-center">
                      <div class="h-3.5 w-28 bg-gray-100 rounded mx-auto"></div>
                    </td>
                    <td class="py-3 px-6 text-center">
                      <div class="h-3.5 w-28 bg-gray-100 rounded mx-auto"></div>
                    </td>
                    <td class="py-3 px-6 text-center">
                      <div class="h-3.5 w-28 bg-gray-100 rounded mx-auto"></div>
                    </td>
                    <td class="py-3 px-6 text-center">
                      <div
                        class="h-8 w-24 bg-gray-200 rounded-lg mx-auto"
                      ></div>
                    </td>
                  </tr>
                </tbody>

                <tbody
                  v-else-if="scoredetails.length > 0"
                  class="divide-y divide-gray-200 bg-white"
                >
                  <tr
                    v-for="(el, index) in scoredetails"
                    :key="el.id"
                    class="hover:bg-gray-50/75 transition-colors duration-150"
                  >
                    <td
                      class="px-4 py-2 border-r border-gray-200 text-center whitespace-nowrap"
                    >
                      <span class="text-sm text-gray-600 font-medium">
                        {{ (currentPage - 1) * pageSize + index + 1 }}
                      </span>
                    </td>
                    <td
                      class="px-6 py-2 border-r border-gray-200 text-left whitespace-nowrap"
                    >
                      <span class="text-xs text-gray-800">{{
                        el.user?.email || "-"
                      }}</span>
                    </td>
                    <td
                      class="px-6 py-2 border-r border-gray-200 text-left whitespace-nowrap"
                    >
                      <span class="text-xs text-gray-500 font-medium">
                        {{ el.user?.display_name || "-" }}
                      </span>
                    </td>
                    <td
                      class="px-6 py-2 border-r border-gray-200 text-center whitespace-nowrap"
                    >
                      <span
                        class="inline-flex items-center gap-1 text-xs font-semibold text-gray-500"
                      >
                        {{ el.user_correct_answers ?? "-" }}
                        <span class="text-gray-400 text-xs">/</span>
                        <span class="text-gray-500">
                          {{ el.max_questions ?? el.total_questions ?? "-" }}
                        </span>
                      </span>
                    </td>
                    <!-- <td
                      class="px-6 py-2 border-r border-gray-200 text-center whitespace-nowrap"
                    >
                      <span class="text-xs text-gray-500 font-medium">
                        {{ el.question_attempt_count || "-" }}
                      </span>
                    </td> -->
                    <td
                      class="px-6 py-2 border-r border-gray-200 text-center whitespace-nowrap"
                    >
                      <span class="text-xs text-gray-500 font-medium" v-if="this.$route.query.lesson_quize === 'false'">
                        {{ el.student_quiz_publish?.attempt ?? "-" }}
                      </span>
                        <span v-else class="text-xs text-gray-500 font-medium">
                        {{ el.question_attempt_count || "-" }}
                      </span>
                    </td>
                    <td
                      class="px-6 py-2 border-r border-gray-200 text-center whitespace-nowrap"
                    >
                    
                      <span class="text-xs text-gray-500 font-medium">
                        {{ el.user_attempt_count || "-" }}
                      </span>
                    </td>
                    <td
                      class="px-6 py-2.5 border-r border-slate-100 text-center whitespace-nowrap align-middle"
                    >
                      <div class="inline-flex items-center justify-center">
                        <span
                          v-if="el.completed"
                          class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold bg-emerald-50 text-emerald-700 ring-1 ring-inset ring-emerald-600/10 transition-all duration-200"
                        >
                          <span
                            class="w-1.5 h-1.5 bg-emerald-500 rounded-full animate-pulse"
                          ></span>
                          Completed
                        </span>
                        <span
                          v-else
                          class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold bg-rose-50 text-rose-700 ring-1 ring-inset ring-rose-600/10 transition-all duration-200"
                        >
                          <span
                            class="w-1.5 h-1.5 bg-rose-400 rounded-full"
                          ></span>
                          Not Attended
                        </span>
                      </div>
                    </td>
                    <td v-if="this.$route.query.lesson_quize === 'false'"
                      class="px-6 py-2.5 border-r border-slate-100 text-center whitespace-nowrap align-middle"
                    >
                      <div class="inline-flex items-center justify-center">
                        <label
                          v-if="el.student_quiz_publish?.id"
                          :key="
                            'pub-' + el.student_quiz_publish.id + '-' + forceKey
                          "
                          class="relative inline-flex items-center cursor-pointer group"
                        >
                          <input
                            type="checkbox"
                            class="sr-only peer"
                            :checked="el.student_quiz_publish?.published"
                            :disabled="
                              togglingPublishId === el.student_quiz_publish.id
                            "
                            @change="toggleQuizPublish(el)"
                          />
                          <!-- Track -->
                          <div
                            :class="[
                              'w-11 h-6 rounded-full transition-all duration-300 ease-in-out shadow-inner',
                              'peer-checked:bg-emerald-500 bg-rose-400',
                              togglingPublishId === el.student_quiz_publish.id
                                ? 'opacity-50 cursor-not-allowed'
                                : '',
                            ]"
                          ></div>
                          <!-- Knob -->
                          <div
                            class="absolute left-0.5 top-0.5 bg-white rounded-full transition-all duration-300 ease-in-out w-5 h-5 shadow-md peer-checked:translate-x-5"
                          ></div>
                        </label>
                        <span v-else class="text-xs text-gray-400">-</span>
                      </div>
                    </td>
                    <td
                      class="px-6 py-2 border-r border-gray-200 text-center whitespace-nowrap"
                    >
                      <span class="text-xs text-gray-500">
                        {{
                          el.finished_at ? formatDateTime(el.finished_at) : "-"
                        }}
                      </span>
                    </td>
                    <td
                      class="px-6 py-2 border-r border-gray-200 text-center whitespace-nowrap"
                    >
                      <router-link
                        v-if="el.completed && el.quiz?.id"
                        :to="{
                          name: 'QuizVaildate',
                          params: {
                            course_id: course_id,
                            quiz_id: el.quiz.id,
                            taker_id: el.id,
                          },
                        }"
                        class="inline-flex items-center gap-1.5 bg-blues hover:bg-blue-600 text-white text-xs font-medium px-4 py-2 rounded-lg"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="h-3.5 w-3.5"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                        Validate
                      </router-link>
                      <span v-else class="text-xs text-gray-400"
                        >Not Available</span
                      >
                    </td>
                  </tr>
                </tbody>

                <tbody v-else>
                  <tr>
                    <td
                      colspan="10"
                      class="text-center py-8 text-gray-600 font-medium"
                    >
                      No Data Found
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="px-4 py-3">
              <div
                class="flex flex-col sm:flex-row items-center justify-between gap-4"
              >
                <div class="flex items-center gap-2 text-sm text-gray-600">
                  <span>Rows per page:</span>
                  <select
                    v-model="pageSize"
                    @change="onPageSizeChange"
                    class="border border-gray-200 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
                  >
                    <option :value="10">10</option>
                    <option :value="20">20</option>
                    <option :value="50">50</option>
                    <option :value="100">100</option>
                  </select>
                </div>
                <div>
                  <Pagination
                    :totalPages="totalPages"
                    ref="paginationRef"
                    @page-changed="quizgetscoreinfo"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- No Data State -->
          <!-- <div
            v-else
            class="flex flex-col items-center justify-center py-16 px-4"
          >
            <div class="bg-gray-50 rounded-full p-6 mb-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-12 w-12 text-gray-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
                />
              </svg>
            </div>
            <p class="text-gray-500 text-lg font-medium">No data found</p>
            <p class="text-gray-400 text-sm mt-1">
              No quiz attempts available yet
            </p>
          </div> -->
        </div>
      </div>
    </div>

    <!-- Attempt Count Modal -->
    <div
      v-if="showAttemptModal"
      class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm px-4"
      @click.self="cancelAttemptModal"
    >
      <div class="bg-white rounded-2xl shadow-xl w-full max-w-sm p-6">
        <h3 class="text-lg font-bold text-gray-800 mb-1">Set Attempt Count</h3>
        <p class="text-sm text-gray-500 mb-4">
          Enter the number of attempts (1-10) to publish this result to the
          student.
        </p>
        <input
          type="number"
          inputmode="numeric"
          v-model.number="attemptInput"
          min="1"
          max="10"
          @keypress="onAttemptKeypress"
          @input="attemptError = ''"
          placeholder="e.g. 3"
          class="w-full rounded-xl border border-gray-200 px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <p v-if="attemptError" class="text-xs text-rose-600 mt-2">
          {{ attemptError }}
        </p>
        <div class="flex justify-end gap-3 mt-6">
          <button
            @click="cancelAttemptModal"
            class="px-4 py-2 rounded-xl text-sm font-medium text-gray-600 hover:bg-gray-100"
          >
            Cancel
          </button>
          <button
            @click="confirmAttemptPublish"
            :disabled="publishSubmitting"
            class="px-4 py-2 rounded-xl text-sm font-semibold text-white bg-blues hover:bg-blue-600 disabled:opacity-50"
          >
            {{ publishSubmitting ? "Publishing..." : "Publish" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Instructor/Header.vue";
import SideBar from "@/components/Instructor/SideBar.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import axios from "axios";
import { mapGetters } from "vuex";
import Pagination from "@/components/Pagination.vue";

export default {
  components: {
    Header,
    SideBar,
    FlashMessage,
    Pagination,
  },
  data() {
    return {
      loading: true,
      currentPage: 1,
      totalPages: 1,
      pageSize: 10,
      searching: "",
      totalcount: "",
      updateDetails: {},
      scoredetails: [],
      isDownload: false,
      togglingPublishId: null,
      showAttemptModal: false,
      attemptInput: null,
      attemptError: "",
      pendingPublishEl: null,
      publishSubmitting: false,
      forceKey: 0,
      messages: {
        text: "",
        type: "null",
      },
    };
  },
  created() {
    this.quizgetscoreinfo(1);
  },
  props: ["quiz_id", "quiz_name", "course_id"],
  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    clearSearch() {
      this.searching = "";
      this.quizgetscoreinfo(1);
    },
    async quizgetscoreinfo(page) {
      this.currentPage = page;
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/coursequizattemptcount/${this.quiz_id}/?Key=${this.userInfo.token_key}&search=${this.searching}&page=${page}&page_size=${this.pageSize}&user__demo_user=false`,
        );
        if (response.data.status == 200) {
          this.scoredetails = response.data?.data?.data;
          this.updateDetails = response.data;
          this.totalcount = response.data.data.total;
          this.totalPages = response.data?.data?.total_page || 1;
        } else {
          this.scoredetails = [];
          this.totalcount = 0;
          console.log("something went wrong.");
        }
      } catch (error) {
        console.error("Error fetching quiz score info:", error);
        this.scoredetails = [];
        this.totalcount = 0;
      } finally {
        setTimeout(() => {
          this.loading = false;
        }, 1000);
      }
    },
    toggleQuizPublish(el) {
      const mapping = el.student_quiz_publish;
      if (!mapping?.id || this.togglingPublishId === mapping.id) return;

      const nextPublished = !mapping.published;
      if (nextPublished) {
        this.pendingPublishEl = el;
        this.attemptInput = mapping.attempt > 0 ? mapping.attempt : null;
        this.attemptError = "";
        this.showAttemptModal = true;
        // Checkbox isn't v-model bound, so force a remount to undo the
        // browser's optimistic toggle until the modal is confirmed.
        this.forceKey++;
        return;
      }
      this.unpublishQuiz(el);
    },
    async unpublishQuiz(el) {
      const mapping = el.student_quiz_publish;
      this.togglingPublishId = mapping.id;
      try {
        const response = await axios.put(
          `${process.env.VUE_APP_API}/student-quiz-mapping-update/${mapping.id}/?Key=${this.userInfo.token_key}`,
          { published: false },
        );
        if (response.data?.status == 200) {
          mapping.published = false;
          this.messages = {
            text: "Quiz unpublished for student successfully",
            type: "success",
          };
        } else {
          this.messages = { text: "Something went wrong.", type: "error" };
        }
      } catch (error) {
        console.error("Error updating publish status:", error);
        this.messages = {
          text: "Request failed. Please try again.",
          type: "error",
        };
      } finally {
        this.togglingPublishId = null;
        this.forceKey++;
        setTimeout(() => {
          this.messages = { text: "", type: "" };
        }, 3000);
      }
    },
    onAttemptKeypress(e) {
      if (!/[0-9]/.test(e.key)) e.preventDefault();
    },
    cancelAttemptModal() {
      this.showAttemptModal = false;
      this.pendingPublishEl = null;
      this.attemptInput = null;
      this.attemptError = "";
      this.forceKey++;
    },
    async confirmAttemptPublish() {
      const value = Number(this.attemptInput);
      if (!Number.isInteger(value) || value < 1 || value > 10) {
        this.attemptError = "Please enter a whole number between 1 and 10.";
        return;
      }
      const el = this.pendingPublishEl;
      const mapping = el?.student_quiz_publish;
      if (!mapping?.id) {
        this.showAttemptModal = false;
        return;
      }

      this.publishSubmitting = true;
      this.togglingPublishId = mapping.id;
      try {
        const response = await axios.put(
          `${process.env.VUE_APP_API}/student-quiz-mapping-update/${mapping.id}/?Key=${this.userInfo.token_key}`,
          { published: true, attempt: value },
        );
        if (response.data?.status == 200) {
          mapping.published = true;
          mapping.attempt = value;
          this.messages = {
            text: "Quiz published for student successfully",
            type: "success",
          };
          this.showAttemptModal = false;
          this.pendingPublishEl = null;
          this.attemptInput = null;
        } else {
          this.messages = { text: "Something went wrong.", type: "error" };
        }
      } catch (error) {
        console.error("Error updating publish status:", error);
        this.messages = {
          text: "Request failed. Please try again.",
          type: "error",
        };
      } finally {
        this.togglingPublishId = null;
        this.publishSubmitting = false;
        this.forceKey++;
        setTimeout(() => {
          this.messages = { text: "", type: "" };
        }, 3000);
      }
    },
    onPageSizeChange() {
      this.currentPage = 1;
      if (this.$refs.paginationRef) {
        this.$refs.paginationRef.currentPage = 1;
      }
      this.quizgetscoreinfo(1);
    },
    formatDateTime(date) {
      const d = new Date(date);
      const formattedDate = d.toLocaleDateString("en-IN", {
        day: "numeric",
        month: "short",
        year: "numeric",
      });
      const formattedTime = d
        .toLocaleTimeString("en-IN", {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          hour12: true,
        })
        .toLowerCase();
      return `${formattedDate} - ${formattedTime}`;
    },
    async scoreDownload() {
      if (this.isDownload) return;
      this.isDownload = true;
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/coursequizdownloadattemptcount/${this.quiz_id}/?Key=${this.userInfo.token_key}`,
        );

        if (response.data) {
          this.messages = {
            text: response.data.message,
            type: "success",
          };
          this.isDownload = false;
          this.$router.push({
            name: "DownloadHistory",
          });
        } else {
          this.messages = {
            text: "Error failed",
            type: "error",
          };
        }

        setTimeout(() => {
          this.messages = { text: "", type: "" };
        }, 3000);
      } catch (error) {
        console.error(error);
        this.messages = {
          text: "Request failed. Please try again.",
          type: "error",
        };
        this.isDownload = false;
        setTimeout(() => {
          this.messages = { text: "", type: "" };
        }, 3000);
      }
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}

/* Custom Scrollbar */
.heightfix::-webkit-scrollbar {
  width: 6px;
}

.heightfix::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.heightfix::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 10px;
}

.heightfix::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Table hover effect */
tbody tr:hover {
  background-color: #f8fafc;
}

/* Smooth transitions */
* {
  transition: all 0.2s ease-in-out;
}
</style>
